<template>
  <section :class="['section-carousel swiper-container ', carousel_sub_class]">
    <div class="swiper-wrapper">
      <div
        :class="[
          'section-carousel__slide swiper-slide',
          slide.slide_theme === 'light'
            ? 'section-carousel__slide--light'
            : 'section-carousel__slide--dark',
        ]"
        v-for="(slide, index) in carousel_slides"
        :key="index"
        :data-swiper-autoplay="slide.slide_duration * 1000"
      >
        <div class="container">
          <h1 class="title" v-html="slide.title" />
          <p class="description" v-html="slide.description" />
          <p class="description--small" v-html="slide.small_text" />
          <a
            class="read-more btn"
            v-if="slide.read_more"
            :href="slide.read_more.url"
            v-text="slide.read_more.title"
          />
        </div>
        <div
          :class="[
            'bg',
            slide.slide_theme === 'light' ? 'bg--light' : 'bg--dark',
          ]"
          v-if="slide.slide_type === 'image'"
          :style="{
            'background-image': 'url( ' + slide.background_image.url + ' )',
            'background-position':
              slide.horizontal_position + '% ' + slide.vertical_position + '%',
          }"
        ></div>
        <video
          :class="[
            'bg',
            slide.slide_theme === 'white' ? 'bg--light' : 'bg--dark',
          ]"
          v-if="slide.slide_type === 'video'"
          :poster="slide.background_video_poster.url"
          autoplay
          muted
          playsinline
          loop
        >
          <source
            v-if="slide.background_video_mp4.url"
            :src="slide.background_video_mp4.url"
            type="video/mp4"
          />
          <source
            v-if="slide.background_video_ogg.url"
            :src="slide.background_video_ogg.url"
            type="video/ogg"
          />
          <source
            v-if="slide.background_video_webm.url"
            :src="slide.background_video_webm.url"
            type="video/webm"
          />
        </video>
      </div>
    </div>
    <div v-if="showSliderArrows" class="section-carousel__prev"></div>
    <div v-if="showSliderArrows" class="section-carousel__next"></div>
  </section>
</template>

<script>
export default {
  props: ["blockdata"],
  name: "block-carousel",
  data() {
    return {
      carousel_slides: this.blockdata.carousel,
      carousel_sub_class: this.blockdata.class,
      curreentCarouselSlide: 0,
      carouselFirstSlide: false,
      showSliderArrows: this.blockdata.carousel.length > 1,
    };
  },
  mounted: function () {
    this.startCarousel();
  },
  methods: {
    startCarousel: function () {
      const carouselSwiper = new Swiper(".section-carousel", {
        loop: true,
        slidesPerView: "auto",
        centeredSlides: true,
        initialSlide: 0,
        autoplay: {
          delay: 5000,
        },
        nextButton: ".section-carousel__next",
        prevButton: ".section-carousel__prev",
        speed: 500,
      });
      carouselSwiper.on("onSlideChangeStart", function () {
        $(".section-carousel")
          .find("video")
          .each(function (i, obj) {
            $(obj)[0].pause();
            $(obj)[0].currentTime = 0;
            $(obj)[0].load();
          });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// BlockCarousel.vue?e0e7b0ba